import * as React from 'react';

export const CloseIcon = ({ onClick, className }: { onClick: () => void; className?: string }) => {
  return (
    <svg width='14px' height='14px' viewBox='0 0 14 14' version='1.1' onClick={onClick} className={className}>
      <g id='Menu-Builder-Reskin' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
        <g id='Menu-Builder-16' transform='translate(-895.000000, -325.000000)' fill='#000000'>
          <g id='Group' transform='translate(334.000000, 300.000000)'>
            <path
              d='M567.520815,31.5208153 L567.520815,24.0208153 C567.520815,23.7446729 567.744673,23.5208153 568.020815,23.5208153 C568.296958,23.5208153 568.520815,23.7446729 568.520815,24.0208153 L568.520815,31.5208153 L576.020815,31.5208153 C576.296958,31.5208153 576.520815,31.7446729 576.520815,32.0208153 C576.520815,32.2969577 576.296958,32.5208153 576.020815,32.5208153 L568.520815,32.5208153 L568.520815,40.0208153 C568.520815,40.2969577 568.296958,40.5208153 568.020815,40.5208153 C567.744673,40.5208153 567.520815,40.2969577 567.520815,40.0208153 L567.520815,32.5208153 L560.020815,32.5208153 C559.744673,32.5208153 559.520815,32.2969577 559.520815,32.0208153 C559.520815,31.7446729 559.744673,31.5208153 560.020815,31.5208153 L567.520815,31.5208153 Z'
              id='Exit-Icon-Copy'
              transform='translate(568.020815, 32.020815) rotate(-45.000000) translate(-568.020815, -32.020815) '
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
};
